import React, { useState, useEffect } from "react";
// import { Navigation } from "./navigation";
import { Header } from "./header";
import { Features } from "./features";
import { About } from "./about";
import { Services } from "./services";
import { Gallery } from "./gallery";
// import { Testimonials } from "./testimonials";
// import { Team } from "./components/Team";
import { Contact } from "./contact";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
// import { Footer } from "./footer";
// import { Route, Routes } from 'react-router-dom';
import "../App.css";
import { Shades } from "./shades";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* <Navigation /> */}
      <Header data={landingPageData.Header} />
      <Gallery data={landingPageData.Gallery} />
      <Shades />
      <Features data={landingPageData.Features} />
      
      <Services data={landingPageData.Services} />
      
      <About data={landingPageData.About} />
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      <Contact />
      {/* <Footer /> */}

     
    </div>
    
  );
};

export default Home;
